<template>
  <div class="content-width py-4">
    <b-button
      squared
      variant="manage_main"
      type="button"
      @click="apiUpdateShoppingNote"
      >儲存</b-button
    >
    <quill-editor ref="quillEdit" v-model="content" :options="editorOption" />
    <ImagePreview
      @childMethod="getImageUrl"
      v-show="false"
      :token="token"
      ref="quillEditImage"
    ></ImagePreview>
  </div>
</template>
<style lang="scss">
.quill-editor {
  background-color: #fff;
  margin-top: 30px;
}
.ql-container {
  font-size: 16px;
}
.ql-snow {
  .ql-tooltip {
    z-index: 100;
  }
  .ql-picker {
    &.ql-size {
      .ql-picker-label,
      .ql-picker-item {
        &::before {
          content: attr(data-value) !important;
        }
      }
    }
  }
  .ql-color-picker .ql-picker-label:last-child svg {
    margin-bottom: 4px;
  }
}
</style>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor, Quill } from "vue-quill-editor";
import ImageResize from "quill-image-resize-module";

const fontSizeArr = [
  "8px",
  "9px",
  "10px",
  "12px",
  "14px",
  "16px",
  "20px",
  "24px",
  "32px",
  "42px",
  "54px",
  "68px",
  "84px",
  "98px"
];

const Size = Quill.import("attributors/style/size");
Size.whitelist = fontSizeArr;

Quill.register("modules/imageResize", ImageResize);
Quill.register(Size, true);

import { Toast } from "@/plugins/sweetalert2.js";
import ImagePreview from "@/components/ImagePreview.vue";
import { ShoppingNote } from "@/assets/api/manage.js";

const toolOptions = [
  // 標題
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  // 字型大小
  [{ size: fontSizeArr }],
  // [{ size: ["small", false, "large", "huge"] }],
  // 加粗 斜體 下劃線 刪除線 字型顏色
  ["bold", "italic", "underline", "strike", { color: [] }],
  // 加粗 斜體 下劃線 刪除線
  ["blockquote", "code-block"],
  // 1、2 級標題
  // [{ header: 1 }, { header: 2 }],
  // 有序、無序列表
  [{ list: "ordered" }, { list: "bullet" }],
  // 上標/下標
  // [{ script: "sub" }, { script: "super" }],
  // 縮排
  [{ indent: "-1" }, { indent: "+1" }],
  // 文字方向
  // [{ direction: "rtl" }],
  //、字型背景顏色
  //[{ background: [] }],
  // 字型種類
  // [{ font: [] }],
  // 對齊方式
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" }
  ],
  // 連結、圖片、影片
  ["link", "image"]
];

export default {
  name: "ShoppingNote",
  props: ["token"],
  components: {
    quillEditor,
    ImagePreview
  },
  data() {
    return {
      content: "",
      editorOption: {
        theme: "snow",
        modules: {
          imageResize: {
            displaySize: true
          },
          toolbar: {
            container: toolOptions,
            handlers: {
              image: () => {
                this.$refs.quillEditImage.$el
                  .querySelector(".custom-file-input")
                  .click();
              }
            }
          }
        }
      }
    };
  },
  created() {
    this.apiGetShoppingNote();
  },
  methods: {
    getImageUrl(data) {
      const range = this.$refs.quillEdit.quill.getSelection();
      this.$refs.quillEdit.quill.insertEmbed(range.index, "image", data);
    },
    apiGetShoppingNote() {
      ShoppingNote.get(this.token)
        .then(res => {
          if (res.status <= 201) {
            this.content = res.data.content;
          } else {
            Toast.fire({
              icon: "error",
              title: "購物須知讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    apiUpdateShoppingNote() {
      ShoppingNote.update({ content: this.content }, this.token)
        .then(res => {
          if (res.status == 200) {
            Toast.fire({
              icon: "success",
              title: "儲存成功"
            });
          } else {
            Toast.fire({
              icon: "error",
              title: "儲存失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  computed: {
    editor() {
      return this.$refs.quillEdit.quill;
    }
  }
};
</script>
